/*
  DataSource : object
  Example Data: {
    contain: (<div>h1</div>),
  }
*/
import React, { PropTypes } from 'react'
import recycle from 'recycle'

const convertElementToArray = element => Array.from(element)

const showMore = recycle({
  initialState: {
    clear: 0,
  },

  effects (sources) {
    return [
      sources.selectClass('box')
        .addListener('onClick')
        .map((e) => {
          const elm = e.target
          const cName = elm.getAttribute('data-btn-id')
          if (elm.getAttribute('id') === `${cName}-btn`) {
            const getelementShowMoreBtn = document.getElementById(`${cName}-btn`)
            const getelementSpin = document.getElementById(`${cName}-spin`)
            const getelementLists = document.getElementsByClassName(cName)
            const getValueNum = +(document.getElementById(`${cName}-num`).value)
            const elementLists = convertElementToArray(getelementLists)
            let time = 0
            getelementShowMoreBtn.style.display = 'none'
            getelementSpin.style.display = ''
            setTimeout(() => {
              getelementSpin.style.display = 'none'
              elementLists.map((value) => {
                value.style.display === '' ? time += 1 : ''
                return 0
              })
              let round
              time + getValueNum <= elementLists.length ? round = time + getValueNum : round = elementLists.length
              for (let i = time; i < round; i += 1) {
                elementLists[i].style.display = ''
              }
              getelementShowMoreBtn.style.display = round !== elementLists.length ? '' : 'none'
              // getelementShowMoreBtn.style.display = ''
            }, 800)
          }
          return e
        }),
    ]
  },

  view ({
    dataSource , // eslint-disable-line
  }) {
    return (
      <div className="box">
        {dataSource.contain}
      </div>
    )
  },

  propTypes: {
    dataSource: PropTypes.object,
  },

})

export default showMore




// WEBPACK FOOTER //
// ./src/components/layouts/showMore.js